export default __webpack_public_path__ + "static/O0105-9315fbac971ac058b6858c3eb5d209e3.png";